import {
  createBrowserRouter,
  Navigate,
  redirect,
  RouteObject,
} from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAxiosInstance } from "../utils/setupInterceptor";
import {
  RecruiterApprovalStatus,
  RecruiterTypes,
  userTypes,
} from "../utils/constants";

import Layout from "../pages/Layout/Layout";
import LandingPage from "../pages/LandingPage/LandingPage";
import LoginPage from "../pages/LoginPage/LoginPage";
import RegisterPage from "../pages/RegisterPage/ResgisterPage";
import EmailVerification from "../pages/EmailVerification/EmailVerification";
import MyAssessmentsPage from "../pages/MyAssessmentsPage/MyAssessmentsPage";
import CreateAssessment from "../pages/MyAssessmentsPage/CreateAssessmentSection/CreateAssessmentSection";
import MyAssessmentsDetailsPage from "../pages/MyAssessmentsDetailsPage/MyAssessmentsDetailsPage";
import CandidateAssessments from "../pages/MyAssessmentsPage/CandidateAssessments/CandidateAssessments";
import AnswerAssessment from "../pages/MyAssessmentsPage/AnswerAssessment/AnswerAssessment";
import Profile from "../pages/ProfilePage/ProfilePage";
import AssessmentListDetails from "../pages/MyAssessmentsPage/AssessmentListDetails/AssessmentListDetails";
import AssessmentView from "../pages/MyAssessmentsPage/AssessmentView/AssessmentView";
import CreateProfile from "../pages/CreateProfile/CreateProfile";
import JobsListPage from "../pages/JobsListPage/JobsListPage";
import VerifyUserJobPage from "../pages/VerifyUserJobPage/VerifyUserJobPage";
import PublicJobDetailPage from "../pages/PublicJobDetailPage/PublicJobDetailPage";
import UnauthorizedPage from "../pages/UnauthorizedPage/UnauthorizedPage";
import ChangePasswordPage from "../pages/ChangePasswordPage/ChangePasswordPage";
import AccountMembers from "../pages/AccountMembersPage/AccountMembers";
import AccountMembersDetail from "../pages/AccountMembersPage/AccountMembersDetail/AccountMembersDetail";
import ViewAgentProfile from "../pages/ViewAgentProfile/ViewAgentProfile";
import AccountPage from "../pages/AccountPage/AccountPage";
import MyAccountDetailsPage from "../pages/MyAccountDetailsPage/MyAccountDetailsPage";
import MyCompanyDetailsPage from "../pages/MyCompanyDetailsPage/MyCompanyDetailsPage";
import RecruiterCreateProfilePage from "../pages/RecruiterCreateProfilePage/RecruiterCreateProfilePage";
import SearchLayout from "../pages/SearchPage/SearchLayout";
import SearchPage from "../pages/SearchPage/SearchPage";
import PossibleMatchPage from "../pages/SearchPage/PossibleMatchPage";
import RequestedDetailsPage from "../pages/SearchPage/RequestedDetailsPage";
import LoginAmbassadorPage from "../pages/Ambassador/Login/Login";
import RegisterAmbassadorPage from "../pages/Ambassador/Register/Register";
import NetworkDetailPage from "../pages/Ambassador/Network/Detail/Detail";
import MatchesPage from "../pages/MatchesPage/MatchesPage";
import Matches2Page from "../pages/Matches2Page/Matches2Page";
import MatchDetailPage from "../pages/MatchDetailPage/MatchDetailPage";
import DetailPage from "../pages/SearchPage/DetailPage";
import TemplateResultPage from "../pages/SearchPage/TemplateResultPage";
import TemplateSearchesPage from "../pages/SearchPage/TemplateSearchesPage";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import UpdateForgotPassword from "../pages/UpdateForgotPassword/UpdateForgotPassword";
import GenerateUserNamePage from "../pages/GenerateUserNamePage/GenerateUserNamePage";
import JobApplyPage from "../pages/JobApplyPage/JobApplyPage";
import JobApplicantDetail from "../pages/JobPage/JobApplicantDetail/JobApplicantDetail";
import { isNullOrEmpty } from "../utils/helperFunction";
import AddReferralPage from "../pages/AddReferralPage/AddReferralPage";
import SettingsPage from "../pages/SettingsPage/SettingsPage";
import MatchesDetailsPage from "../pages/MatchesPage/MatchesDetailsPage";
import PaymentMethodPage from "../pages/Stripe/PaymentMethodPage";
import BalancePage from "../pages/Stripe/BalancePage";
import NotificationPage from "../pages/NotificationPage/NotificationPage";
import { getPaymentMethods } from "../endpoints/stripe.service";
import { setSearchData } from "../store/actions/search.action";
import { setPaymentMethods } from "../store/actions/payment.action";
import {
  fetchJobMessagesProfile,
  fetchUnseenMessageCount,
} from "../store/actions/message.action";
import TransactionPage from "../pages/TransactionPage/TransactionPage";
import TransactionDetailPage from "../pages/TransactionPage/TransactionDetailPage";
import ReferralMemberPage from "../pages/ReferralMemberPage/ReferralMemberPage";
import JobApplicationDetail from "../pages/Ambassador/Network/JobApplicationDetail/JobApplicationDetail";
import { RecruiterCheckoutPage } from "../pages/Stripe/RecruiterCheckoutPage";
import JobMatchesPage from "../pages/JobMatchesPage/jobMatchesPage";
import JobMatchedDetailPage from "../pages/JobMatchesPage/JobMatchedDetailPage";
import AspirationPage from "../pages/AspirationPage/AspirationPage";
import AddReferralAccount from "../pages/AddReferralAccount/AddReferralAccount";
import Privacy from "../pages/SettingsPage/privacy/privacy";
import HiringCompanyLoginPage from "../pages/LoginPage/hiringCompany";
import HiringCompanyRegisterPage from "../pages/LoginPage/hiringCompanyRegister";
import CounterProposalPollPage from "@pages/CounterProposalPollPage/CounterProposalPollPage";
import TransactionUserDetailPage from "@pages/TransactionPage/TransactionUserDetailPage";
import store from "@store/index";
import { RecruiterRoutes } from "./RecruiterRoutes";
import { HiringCompanyRoutes } from "./HiringCompanyRoutes";
import { CandidateRoutes } from "./CandidateRoutes";
import MeetingDetailPage from "@pages/MeetingDetailPage/MeetingDetailPage";
import { ReferralAmbassadorRoutes } from "./ReferralAmbassadorRoutes";
import DashboardPage from "@pages/Dashboard/Dashboard";
import MessagePage from "@pages/MessagesPage/MessagesPage";

export function routerLoaders() {
  const loginLoader = ({ request }: any) => {
    const { authenticated, user } = store.getState().auth;
    if (authenticated && user && user?._id && !isNullOrEmpty(user?.userName)) {
      return redirect("/");
    }
    return null;
  };

  const authLoader = ({ request }: any) => {
    const { authenticated, user } = store.getState().auth;
    if (!authenticated && !user && isNullOrEmpty(user?._id)) {
      return redirect("/login");
    }

    if (authenticated && user && user?._id && isNullOrEmpty(user?.userName)) {
      return redirect("/generate-user-name");
    }
    return null;
  };

  return { loginLoader, authLoader };
}

export function useAuthLoader() {
  const auth = useSelector((state: any) => state.auth);
  const { authenticated, user } = auth;

  const loginLoader = ({ request }: any) => {
    if (authenticated && user && user?._id && !isNullOrEmpty(user?.userName)) {
      return redirect("/");
    }
    return null;
  };

  const authLoader = ({ request }: any) => {
    if (!authenticated && !user && isNullOrEmpty(user?._id)) {
      return redirect("/login");
    }

    if (authenticated && user && user?._id && isNullOrEmpty(user?.userName)) {
      return redirect("/generate-user-name");
    }
    // window.alert('check')
    return null;
  };

  return {
    loginLoader,
    authLoader,
  };
}

function useRoutes() {
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);
  const { loginLoader, authLoader } = useAuthLoader();
  useAxiosInstance();

  const isLoggedIn =
    (auth.authenticated && auth.user && auth.user._id) ||
    auth?.user?.userType === userTypes.REFERRAL_AMBASSADOR;

  const userNameNotExist = isLoggedIn && isNullOrEmpty(auth?.user?.userName);

  const isRecruiter = auth?.user?.userType === userTypes.RECRUITER;
  const isCandidate = auth?.user?.userType === userTypes.CANDIDATE;
  const isReferrealAmbassador =
    auth?.user?.userType === userTypes.REFERRAL_AMBASSADOR;
  const isRecruiterAdmin =
    isRecruiter && auth?.user?.recruiterType === RecruiterTypes?.ADMIN;
  const isHiringCompany = auth?.user?.userType === userTypes.HIRING_COMPANY;

  let layoutChildren: RouteObject[] = [
    {
      path: "/",
      element: isLoggedIn ? (
        isRecruiterAdmin &&
        (!auth?.user?.recruiterApprovalStatus ||
          auth?.user?.recruiterApprovalStatus ===
            RecruiterApprovalStatus.REQUESTED) ? (
          <Navigate to="/create-profile" />
        ) : userNameNotExist ? (
          <Navigate to="/generate-user-name" />
        ) : isCandidate && auth?.user?.enableDefaultProfileOption ? (
          // Candidate
          <Navigate to="/create-profile" />
        ) : isCandidate || isRecruiter || isReferrealAmbassador ? (
          <Navigate to="/dashboard" />
        ) : isHiringCompany ? (
          <Navigate to="/requirements" />
        ) : null
      ) : (
        <LandingPage />
      ),
    },
    /**
     * Stripe route starts
     */

    // {
    //   path: "/checkout",
    //   loader: authLoader,
    //   element: <CheckoutPage />,
    // },
    // {
    //   path: "/subscription-plans",
    //   loader: authLoader,
    //   element: <SubscriptionPlanPage />,
    // },
    {
      path: "/",
    },
    {
      path: "/payment-method",
      loader: authLoader,
      element: <PaymentMethodPage />,
    },
    {
      path: "/recruiter-checkout",
      loader: authLoader,
      element: (
        <RecruiterCheckoutPage onPaymentSuccess={() => {}} currentJobId="" />
      ),
    },
    {
      path: "/messages",
      loader: authLoader,
      element: <MessagePage />,
    },
    {
      path: "/balance",
      loader: authLoader,
      element: <BalancePage />,
    },
    {
      path: "/notifications",
      loader: authLoader,
      element: <NotificationPage />,
    },

    /**
     * Stripe route ends
     */
    {
      path: "/login",
      loader: loginLoader,
      element: <LoginPage />,
    },
    {
      path: "/hiring/login",
      loader: loginLoader,
      element: <HiringCompanyLoginPage />,
    },
    {
      path: "/hiring/register",
      loader: loginLoader,
      element: <HiringCompanyRegisterPage />,
    },
    {
      path: "/login-ambassador",
      loader: loginLoader,
      element: <LoginAmbassadorPage />,
    },
    {
      path: "/email-verification",
      loader: loginLoader,
      element: <EmailVerification />,
    },
    {
      path: "/forgot-password",
      loader: loginLoader,
      element: <ForgotPassword />,
    },
    {
      path: "/update-forgot-password",
      loader: loginLoader,
      element: <UpdateForgotPassword />,
    },
    {
      path: "/generate-user-name",
      loader: loginLoader,
      element: <GenerateUserNamePage />,
    },
    {
      path: "/add-referral",
      loader: loginLoader,
      element: <AddReferralPage />,
    },
    {
      path: "/register",
      loader: loginLoader,
      element: <RegisterPage />,
    },
    {
      path: "/register/:path",
      loader: loginLoader,
      element: <RegisterPage />,
    },
    {
      path: "/register-ambassador",
      loader: loginLoader,
      element: <RegisterAmbassadorPage />,
    },
    {
      path: "/verify-job/:jobId/:email",
      element: <VerifyUserJobPage />,
    },
    {
      path: "/create-profile",
      loader: authLoader,
      element:
        auth?.user?.userType === 2 ? (
          <RecruiterCreateProfilePage />
        ) : (
          <CreateProfile />
        ),
    },
    /**
     * Transaction
     *
     */
    {
      path: "/transactions",
      loader: authLoader,
      element: <TransactionPage />,
    },
    {
      path: "/transactions/details/:id/:type",
      loader: authLoader,
      element: <TransactionDetailPage />,
    },
    {
      path: "/transactions/user-details/:userId/:jobId",
      loader: authLoader,
      element: <TransactionUserDetailPage />,
    },
    {
      path: "/matches",
      loader: authLoader,
      children: [
        {
          index: true,
          element: <MatchesPage />,
        },
        {
          path: ":candidateId/:jobId",
          loader: authLoader,
          element: <MatchesDetailsPage />,
        },
      ],
    },
    {
      path: "/matches-2",
      loader: authLoader,
      children: [
        {
          index: true,
          element: <Matches2Page />,
        },
        {
          path: "match-detail",
          loader: authLoader,
          element: <MatchDetailPage />,
        },
      ],
    },
    {
      path: "/unauthorized",
      loader: authLoader,
      element: <UnauthorizedPage />,
    },
    {
      path: "/search",
      loader: authLoader,
      element: <SearchLayout />,
      children: [
        {
          index: true,
          element: <SearchPage />,
        },
        {
          path: "possible-match",
          element: <PossibleMatchPage />,
        },
        {
          path: "template-result",
          element: <TemplateResultPage />,
        },
        {
          path: "template-searches",
          element: <TemplateSearchesPage />,
        },
        {
          path: "requested-details",
          element: <RequestedDetailsPage />,
        },
      ],
    },
    {
      path: "/search/match-detail",
      element: <DetailPage />,
    },
    {
      path: "/search/search-user-profile",
      element: <NetworkDetailPage />,
    },
 
    {
      path: "/my-assessments",
      loader: authLoader,
      children: [
        {
          index: true,
          element: <MyAssessmentsPage />,
        },
        {
          path: "assessment-details/:id",
          element: <MyAssessmentsDetailsPage />,
        },
        {
          path: "create-assessment",
          element: <CreateAssessment />,
        },
        {
          path: "edit-assessment/:assessmentId",
          element: <CreateAssessment />,
        },
        {
          path: "assessment-details",
          element: <AssessmentListDetails />,
        },
        {
          path: "assessment-view/:assessmentId",
          element: <AssessmentView />,
        },
        {
          path: "candidate-Assessments",
          element: <CandidateAssessments />,
        },
        {
          path: "candidate-Assessments/:id",
          element: <AnswerAssessment />,
        },
      ],
    },
    // {
    //   path: "/profile",
    //   loader: authLoader,
    //   children: [
    //     {
    //       index: true,
    //       element: <AgentProfile />,
    //     },
    //   ],
    // },
    {
      path: "/view-profile",
      loader: authLoader,
      children: [
        {
          index: true,
          element: <ViewAgentProfile />,
        },
      ],
    },
    {
      path: "/meeting-poll-details",
      element: <MeetingDetailPage />,
    },
    {
      path: "/meeting-details",
      element: <MeetingDetailPage />,
    },
    {
      path: "/counter-proposal-poll",
      element: <CounterProposalPollPage />,
    },
    {
      path: "/job-search",
      children: [
        {
          index: true,
          loader: authLoader,
          element: <JobsListPage />,
        },
        {
          path: ":id",
          loader: authLoader,
          element: <JobApplyPage />,
        },
      ],
    },
    {
      path: "job-detail/:jobId",
      element: <PublicJobDetailPage />,
    },
    {
      loader: authLoader,
      path: "job-applicant-detail",
      element: <JobApplicantDetail />,
    },
    {
      loader: authLoader,
      path: "/add-referral-account",
      element: <AddReferralAccount />,
    },
    {
      loader: authLoader,
      path: "/account/account-members/:id",
      element: <AccountMembersDetail />,
    },
    {
      path: "/my-profile",
      loader: authLoader,
      element: <Profile />,
    },
    {
      path: "/change-password",
      loader: authLoader,
      element: <ChangePasswordPage />,
    },
    {
      path: "/job-matches",
      loader: authLoader,
      children: [
        {
          index: true,
          element: <JobMatchesPage />,
        },
        {
          path: "job-matches-details",
          element: <JobMatchedDetailPage />,
        },
      ],
    },

    {
      path: "/aspiration",
      loader: authLoader,
      element: <AspirationPage />,
    },
    {
      path: "/job-application-detail",
      loader: authLoader,
      element: <JobApplicationDetail />,
    },

    // {
    //   path: "/messages",
    //   loader: authLoader,
    //   element: <MembersProfilePage />,
    //   children: [
    //     {
    //       path: ":jobId",
    //       loader: authLoader,
    //       element: <MessageView />,
    //     },
    //   ],
    // },
    {
      path: "/referral-member",
      loader: authLoader,
      element: <ReferralMemberPage />,
    },
    {
      path: "*",
      loader: authLoader,
      element: <DashboardPage />,
    },
    {
      path: "/settings",
      loader: authLoader,
      element: <SettingsPage />,
      children: [
        {
          path: "/settings/privacy",
          element: <Privacy />,
        },
      ],
    },
  ];

  if (isHiringCompany) {
    layoutChildren.push(...HiringCompanyRoutes);
  }

  if (isRecruiter) {
    layoutChildren.push(...RecruiterRoutes);
  }

  if (isCandidate) {
    layoutChildren.push(...CandidateRoutes);
  }

  if (isReferrealAmbassador) {
    layoutChildren.push(...ReferralAmbassadorRoutes);
  } else {
    layoutChildren.push({
      path: "/account",
      loader: authLoader,
      children: [
        {
          path: "",
          element: <AccountPage />,
          children: [
            {
              path: "/account/account-members",
              element: <AccountMembers />,
            },
            {
              path: "/account/my-company-details",
              element: <MyCompanyDetailsPage />,
            },
            {
              path: "/account/my-account-details",
              element: <MyAccountDetailsPage />,
            },
          ],
        },
      ],
    });
  }

  const feedSearchData = async () => {
    const searchData = JSON.parse(localStorage.getItem("searchData"));
    dispatch(setSearchData({ ...searchData }));
  };

  const feedPaymentMethods = async () => {
    if (
      [userTypes.RECRUITER, userTypes?.REFERRAL_AMBASSADOR]?.includes(
        auth?.user?.userType
      )
    ) {
      getPaymentMethods("card")
        .then((response) => {
          if (response.success) {
            dispatch(setPaymentMethods({ cards: response?.data || [] }));
          }
        })
        .catch((error) => {});
      getPaymentMethods("bacs_debit")
        .then((response) => {
          if (response.success) {
            dispatch(setPaymentMethods({ banks: response?.data || [] }));
          }
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    if (isLoggedIn && auth?.user?.token) {
      feedSearchData();
      feedPaymentMethods();
      if (auth?.user?.userType !== userTypes.HIRING_COMPANY) {
        dispatch(fetchJobMessagesProfile());
        dispatch(fetchUnseenMessageCount());
      }
    }
  }, [isLoggedIn, auth?.user?.token]);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: layoutChildren,
    },
  ]);

  return {
    router,
  };
}
export default useRoutes;
